import React, { Component, Fragment } from "react";

import { Icon, Form } from "components";

class Message extends Component {
  state = {
    open: false,
  };

  handleToggle = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  render() {
    const { open } = this.state;
    const { message, selected, onSelect } = this.props;

    const statusLabel = () => {
      const { status } = message.attributes;

      switch (status) {
        case 'processing':
          return "processando";
        case 'processed':
          return "processado";
        case 'failed':
          return "falhou";
        default:
          return "pendente";
      }
    };

    return (
      <Fragment>
        <tr>
          <td>
            <Form.Checkbox checked={selected} onChange={onSelect} />
          </td>
          <td>{message.attributes.topic.name}</td>
          <td>{message.attributes.message_offset}</td>
          <td>{message.attributes.message_key}</td>
          <td>{statusLabel()}</td>
          <td>{message.attributes.error_description}</td>
          <td>{message.attributes.processed_at}</td>
          <td>{message.attributes.created_at}</td>
          <td className="text-right">
            <button className="button-icon" onClick={this.handleToggle}>
              <Icon name="plus" prefix="fa" />
            </button>
          </td>
        </tr>
        {open && (
          <pre>
            <tr>
              <td colSpan="7" style={{ maxWidth: 300 }}>
                {JSON.stringify(message.attributes.message_content, null, 4)}
              </td>
            </tr>
          </pre>
        )}
      </Fragment>
    );
  }
}

export default Message;
